import React from "react";

export const UploadSummaryCard = () => (
  <div className="rounded-2xl sm:rounded-3xl bg-gradient-to-br from-sky-500/40 via-sky-600/30 to-slate-900/60 p-4 sm:p-5 md:p-6 h-full flex flex-col justify-center">
    <h2 className="text-xs sm:text-sm md:text-base font-semibold text-jp-ink mb-2 sm:mb-3">
      TEAM ROSTER & AI MATCH SUGGESTIONS
    </h2>
    <p className="text-[11px] sm:text-xs md:text-sm text-jp-ink leading-relaxed">
      Upload your team data and discover JUCO players that match your roster needs.
    </p>
  </div>
);
